import { render, staticRenderFns } from "./lockExchangeRateTable.vue?vue&type=template&id=5498ac0a&scoped=true"
import script from "./lockExchangeRateTable.vue?vue&type=script&lang=js"
export * from "./lockExchangeRateTable.vue?vue&type=script&lang=js"
import style0 from "./lockExchangeRateTable.vue?vue&type=style&index=0&id=5498ac0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5498ac0a",
  null
  
)

export default component.exports